import ready from './lib/ready';
import promiseIdle from './lib/promise-idle';
import mergeOpts from './lib/merge-opts';
import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';

export const defaults = {
    modules: [Navigation, Pagination, Autoplay],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};

ready().then(promiseIdle()).then(function init() {
    reload() && document.addEventListener('reload', function () {
        Promise.resolve().then(promiseIdle()).then(reload);
    });
});

function reload() {
    document.querySelectorAll('.slider--auto:not(.slick-initialized)').forEach(function (slider) {
        const o = JSON.parse(slider.getAttribute('data-slider-options')) || {};
        const options = mergeOpts(defaults, o);

        const list = slider.querySelector('.swiper-wrapper');
        
        if (options.loop) {
            options.on = {
                breakpoint: function (swiper, params) {
                    const clones = list.querySelectorAll('.swiper-slide.clone');
                   
                    if (!params.clones) {
                        // remove all clones
                        clones.forEach(clone => clone.remove());
                        return;
                    }

                    const slides = list.querySelectorAll('.swiper-slide:not(.clone)');

                    if (params.clones * slides.length === clones.length / slides.length - 1) {
                        return;
                    }

                    // remove all clones
                    clones.forEach(clone => clone.remove());

                    // create clones
                    for (let i = 0; i < params.clones; ++i) {
                        slides.forEach(slide => {
                            const clone = slide.cloneNode(true);
                            clone.classList.add('clone');
                            list.appendChild(clone);
                        });
                    }

                    swiper.updateSlides();
                },
            };
        }

        new Swiper(slider, options);
    });
}
